import { render, staticRenderFns } from "./PortalSidebar.vue?vue&type=template&id=7eee273a&scoped=true&"
import script from "./PortalSidebar.vue?vue&type=script&lang=js&"
export * from "./PortalSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PortalSidebar.vue?vue&type=style&index=0&id=7eee273a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eee273a",
  null
  
)

export default component.exports